/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import { Checkbox } from '@mui/material';
import InfoHover from '@components/Hover';
import classes from './Widget.module.css';

const TOOLTIP_TEXT = "If your package is lost in transit, you'll be compensated for the item value.";

export const Widget = ({
  checked, insuranceFee, quotePrice, handleWidgetChange,
}) => {
  const handleChange = (e) => {
    handleWidgetChange(e.target.checked);
  };
  return (
    insuranceFee
      ? (
        <div className={classes.widget_wrapper}>
          <Checkbox
            checked={checked}
            onChange={handleChange}
            color="input"
            style={{ padding: '0px', paddingRight: 10 }}
            sx={{
              '&.Mui-checked': { color: '#2C6ECB' },
            }}
          />
          <div className={classes.widget_content}>
            <div className={classes.primary}>
              <div className={classes.title}>Include Shipping Protection</div>
              <InfoHover
                title={TOOLTIP_TEXT}
                infoIcon={(
                  <img
                    src="https://cdn.seel.com/assets/images/buyer-protection/info_icon.svg"
                    alt=""
                    className={classes.info_icon}
                  />
                )}
                style={{ background: '#fff', color: '#000' }}
              />

            </div>
            <div className={classes.secondary}>{`Protect against loss for ${quotePrice}`}</div>
          </div>
          <div className={classes.money}>{insuranceFee}</div>
        </div>
      ) : null
  );
};
